import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

interface ChangeUserEmailPayload {
  email?: string;
  emailAuthentication?: string;
}

async function changeUserEmail(
  userUid: string,
  payload: ChangeUserEmailPayload,
  auth: Authentication
): Promise<void> {
  try {
    await HttpClient.put(`/backoffice/users/${userUid}/email`, payload, auth.token);
  } catch (e: any) {
    console.error('changeUserEmail error:', e);
    throw new ChangeUserEmailFailure(e.message);
  }
}

export class ChangeUserEmailFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default changeUserEmail;
